export const GET_APPLICATION_SUBSTATUS_DEF = "/ApplicationSubStatusDef/GetAllApplicationSubStatusDef"